var _a, _b;
import * as tslib_1 from "tslib";
import { handleActions } from 'redux-actions';
import { fetchArtAuthorSuccess } from './actions';
import { reduxKey } from './constants';
var defaultState = {
    artAuthor: undefined,
};
var handleFetchPopupArtAuthorSuccess = function (state, _a) {
    var payload = _a.payload;
    var user = payload.user;
    return tslib_1.__assign({}, state, { artAuthor: user });
};
var reducer = handleActions((_a = {},
    _a[fetchArtAuthorSuccess.toString()] = handleFetchPopupArtAuthorSuccess,
    _a), defaultState);
export default (_b = {},
    _b[reduxKey] = reducer,
    _b);
//# sourceMappingURL=reducers.js.map